/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * OpenAPI spec version: 1.0.32
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CategoryResult } from './categoryResult';
import { GroupCategoryResult } from './groupCategoryResult';
import { GroupReportInfo } from './groupReportInfo';
import { Legend } from './legend';
import { Test } from './test';

/**
 * Base class serializer for all OpenAPI serializers.  It only implements create/update method without any logic to prevent \"abstract\" warning by pylint.
 */
export interface BasicGroupOpenApi { 
    groupReportInfo: GroupReportInfo;
    categoryResults: Array<CategoryResult>;
    problematicCategories: Array<GroupCategoryResult>;
    test: Test;
    legend: Array<Legend>;
}